import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"

export const ProgressStyles = makeStyles((theme: Theme) => createStyles({
	linearProgressMain: {
		backgroundColor: "#dddddd !important",
	},
	linearProgressPrimary: {
		backgroundColor: "#0b9a64 !important",
	},
	linearProgressDeterminate: {
		height: "6px !important",
	},
	linearProgressbar1Determinate: {
		borderRadius: 8
	}

}));